export default [
  {
    title: "Activity",
    customIcon: "CustomSVG",
    children: [
      {
        title: "Activity List",
        route: "custom-module",
        path: "/custom-module/activity",
      },
    ],
  },
];
